/*
 * BUBBLEBUTTONS COMPONENT
 *
 * RENDERS A SET OF PREDEFINED SUGGESTION BUBBLES AND A CLOSE ICON.
 * CALLS onBubbleClick WITH THE SUGGESTION TEXT WHEN A BUBBLE IS CLICKED.
 * CALLS onCloseBubbles WHEN THE CLOSE ICON IS CLICKED TO DISMISS ALL BUBBLES.
 */

import React from 'react';
import PropTypes from 'prop-types';
import styles from './BubbleButtons.module.scss';

/**
 * @param {Object} props
 * @param {() => void} props.onCloseBubbles – Callback to hide all suggestion bubbles.
 * @param {(message: string) => void} props.onBubbleClick – Callback invoked with the suggestion text.
 */
export default function BubbleButtons({ onCloseBubbles, onBubbleClick }) {
  return (
    <div className={styles.bubbleContainer}>
      <div className={styles.bubbleWithClose}>
        {/* Primary suggestion bubble with embedded close control */}
        <button
          className={styles.bubble}
          onClick={() => onBubbleClick("Jag vill hitta rätt utbildning - var börjar jag?")}
        >
          Jag vill hitta rätt utbildning
        </button>
        <button
          className={styles.closeCircle}
          onClick={onCloseBubbles}
          aria-label="Close suggestions"
        >
          <img
            src="/assets/close-circle.svg"
            alt="Close circle background"
            className={styles.closeCircleImg}
          />
          <img
            src="/assets/x-icon.svg"
            alt="X icon"
            className={styles.xIcon}
          />
        </button>
      </div>

      {/* Additional suggestion bubbles */}
      <button
        className={styles.bubble}
        onClick={() => onBubbleClick("Jag vill veta mer om Städakademin")}
      >
        Jag vill veta mer om Städakademins
      </button>
      <button
        className={styles.bubble}
        onClick={() => onBubbleClick("Jag vill veta mer om era konsulttjänster - kan ni guida mig?")}
      >
        Jag vill veta mer om era konsulttjänster
      </button>
    </div>
  );
}

BubbleButtons.propTypes = {
  onCloseBubbles: PropTypes.func.isRequired,
  onBubbleClick: PropTypes.func.isRequired,
};
